import cls from './Loading.module.scss';
import trenerLoading from '../../shared/assets/images/trener_loading.gif';
import RandomSpeech from '../../features/RandomSpeech/RandomSpeech';
import cloudImg from '../../shared/assets/images/cloud-1.svg';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setPage } from '../../shared/redux/pages/slice';
import { Pages } from '../../shared/redux/pages/types';

const Loading = () => {
  const dispath = useDispatch();
  useEffect(() => {
    const interval = setInterval(() => {
      dispath(setPage(Pages.START));
    }, 5000);
    return () => clearInterval(interval);
  }, []);
  return (
    <div className={cls.Loading}>
      <div className={cls.contentContainer}>
        <img alt="cloud" src={cloudImg} className={cls.cloudImage} />
        <img alt="trener" src={trenerLoading} className={cls.trener} />
        <div className={cls.text}>
          <h1 className={cls.second_p}>Загрузка</h1>
          <h1 className={cls.first_p}>Загрузка</h1>
        </div>
        <RandomSpeech />
      </div>
    </div>
  );
};

export default Loading;
